import { render } from "@/components/pages/dataRecollection/cancelCode/CancelCodePage.html?vue&type=template&id=6fb8f462&external"
import script from "@/components/pages/dataRecollection/cancelCode/CancelCodePage.js?vue&type=script&lang=js&external"
export * from "@/components/pages/dataRecollection/cancelCode/CancelCodePage.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__